import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Col, Grid, Row } from 'react-bootstrap'
import injectSheet from 'react-jss'
import TopBar from 'src/components/top_bar/TopBar'
import Footer from 'src/components/footer/Footer'
import MapProducers from './components/MapProducers/MapProducers.container'
import ListeProducteurs from 'src/components/ListeProducteurs'
import { getMediaQuerySize } from 'src/utils'
import TopBarSearch from 'src/components/top_bar/TopBarSearch'
import { Helmet } from 'react-helmet'
import responsiveComponent from 'src/hoc/responsiveComponent'
import PubContainer from 'src/components/PubContainer'
import { mapAd, mapAdLgSmLimitSize, smBannerAd } from 'src/config/dataConf'
import useWindowWidth from '../../../hooks/useWindowWidth'
import { Redirect } from 'react-router'
import routes from '../../../routing/routes'

const styles = theme => {
  const mediaQuery = getMediaQuerySize()
  return {
    wrapper: {
      backgroundColor: props =>
        props.isMobile ? 'white' : theme.backgroundColor,
      minHeight: theme.minHeight
    },
    topFix: {
      position: 'fixed',
      zIndex: 1,
      padding: '0 30px',
      height: 147.75,
      [mediaQuery]: {
        height: 83.75
      }
    },
    paddingTop: {
      height: 147.75,
      [mediaQuery]: {
        paddingTop: 83.75
      }
    },
    noPadding: {
      padding: 0
    },
    pub: {
      backgroundColor: theme.backgroundColor,
      position: 'fixed',
      top: 147.75,
      right: 0,
      height: 120,
      width: '66.66%',
      textAlign: 'center',
      [mediaQuery]: {
        top: 83.75
      }
    }
  }
}

const Recherche = ({
  classes,
  coordinates,
  updateBounds,
  bounds,
  isMobile,
  data,
  page,
  loading
}) => {
  const windowWidth = useWindowWidth()

  return !bounds && coordinates.length < 2 ? (
    <Redirect to={routes.accueil} />
  ) : (
    <Fragment>
      <Helmet>
        <title>Recherche des producteurs proche de chez vous</title>
        <meta name='robots' content='noindex' />
      </Helmet>

      <div className={classes.wrapper}>
        <div className='visible-xs-block'>
          <TopBar />
        </div>

        <div className='hidden-xs'>
          <TopBarSearch bleu className={classes.topFix} />
          <div className={classes.paddingTop} />
        </div>

        <Grid fluid>
          <Row>
            <Col xs={12} sm={4}>
              {bounds && (
                <ListeProducteurs loading={loading} data={data} page={page} />
              )}
            </Col>

            {!isMobile ? (
              <PubContainer
                className={classes.pub}
                scriptPubCore={
                  windowWidth > mapAdLgSmLimitSize ? smBannerAd : mapAd
                }
              />
            ) : null}

            {(coordinates || bounds) && (
              <MapProducers
                updateBounds={updateBounds}
                coordinates={coordinates}
                bounds={bounds}
                data={data}
                loading={loading}
              />
            )}
          </Row>
        </Grid>
      </div>

      <Grid fluid>
        <Row>
          <Col xs={12} sm={4} className={classes.noPadding}>
            <Footer />
          </Col>
        </Row>
      </Grid>
    </Fragment>
  )
}

export default responsiveComponent(injectSheet(styles)(Recherche))

Recherche.propTypes = {
  bounds: PropTypes.array,
  coordinates: PropTypes.array,
  data: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  updateBounds: PropTypes.func.isRequired
}
